import React from 'react';
import './style/Loading.css';
import { connect } from 'react-redux';
import { getString } from '../../../api/redux-watson/watson-config-selectors';
import SimpleThemer from 'app/ui/config/SimpleThemer';

function Circle({ color }) {
  return (
    <SimpleThemer
      backgroundColor={color}
      mergeClasses="Loading__Circle"
      render={className => <div className={className} />}
    />
  );
}

function Loading({ alt, colors }) {
  return (
    <div className="Loading" role="img" aria-label={alt}>
      <Circle color={colors[0]} />
      <Circle color={colors[1]} />
      <Circle color={colors[2]} />
      <Circle color={colors[3]} />
      <Circle color={colors[4]} />
    </div>
  );
}

Loading.defaultProps = {
  colors: [],
};

const mapStateToProps = state => ({
  alt: getString(state, 'common.general.loading'),
});

export default connect(mapStateToProps)(Loading);

export const LoadingTest = Loading;



// WEBPACK FOOTER //
// ./src/app/ui/core/common/Loading.js